import { Injectable } from '@angular/core';
var BsDatepickerEffects = (function () {
    function BsDatepickerEffects() {
    }
    // constructor(private _bsDatepickerStore: BsDatepickerStore,
    //             private _actions: BsDatepickerActions) {
    //   this.onMonthCalendarCalculation();
    // }
    //
    // onMonthCalendarCalculation() {
    //   this._bsDatepickerStore
    //     .select(state => state.monthModel)
    //     .filter(monthModel => !!monthModel)
    //     .subscribe(month =>
    //       this._bsDatepickerStore.dispatch(this._actions.format()));
    // }
    BsDatepickerEffects.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    BsDatepickerEffects.ctorParameters = function () { return []; };
    return BsDatepickerEffects;
}());
export { BsDatepickerEffects };
//# sourceMappingURL=bs-datepicker.effects.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/datepicker/reducer/bs-datepicker.effects.js
// module id = 868
// module chunks = 103